import { i18n } from "utils/util";

function get_bgm_link(slug) {
  return i18n(`images/common/bgm/${slug}.mp3`);
}

export const mp3Link = {
  home: get_bgm_link("bg-home"),
  introduction: get_bgm_link("bg1"),
  "background-to-Almighty-God-s-work": get_bgm_link("bg2"),
  "Son-of-man-begins-speaking-in-house-churches": get_bgm_link("bg3"),
  "six-trials-of-God-s-judgment-work": get_bgm_link("bg4"),
  "God-incarnate-and-man-used-by-God": get_bgm_link("bg5"),
  "testimonies-of-being-cleansed-through-judgment": get_bgm_link("bg6"),
  "spread-of-kingdom-gospel": get_bgm_link("bg7"),
  "the-word-appears-in-the-flesh": get_bgm_link("bg8"),
  conclusion: get_bgm_link("bg8"),
};
